import { db } from "../../../config/firebaseconfig"

export default function saveImageDataToDb(imageName, imagePath, imageId, imageExt, url) {
  const timestamp = Date.now()
  const imageData = {
    id: imageId,
    path: imagePath,
    timestamp,
    name: imageName,
    extension: imageExt,
    url,
  }
  return db.collection('images').doc(imageId).set(imageData)
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageContent/saveImageDataToDb.js